import { watch } from 'vue'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { defineNuxtPlugin, useGtag, useRuntimeConfig } from '#imports'
import { ConsoleAnalyticsProvider } from '~/shared/analytics/providers/ConsoleAnalyticsProvider'
import { GtagAnalyticsProvider } from '~/shared/analytics/providers/GtagAnalyticsProvider'
import type { AnalyticsProvider } from '~/shared/analytics/types'

export default defineNuxtPlugin({
  name: 'analytics',
  setup (nuxtApp) {
    const config = useRuntimeConfig().public
    const environment = (config.environment as string) || 'production'
    const measurementId = (config.googleAnalyticsId as string) || ''
    const appVersion = (config.appVersion as string) || 'unknown'

    let provider: AnalyticsProvider

    if (environment === 'development') {
      provider = new ConsoleAnalyticsProvider()
    } else if (measurementId) {
      const { gtag } = useGtag()
      provider = new GtagAnalyticsProvider(gtag as (...args: unknown[]) => void, measurementId)
    } else {
      provider = new ConsoleAnalyticsProvider()
    }

    provider.setContext({
      erpVersion: appVersion,
      environment
    })

    const authStore = useAuthenticationStore()

    watch(
      () => ({
        userId: authStore.user?.id,
        companyId: authStore.companies?.[0]?.id
      }),
      ({ userId, companyId }) => {
        if (userId != null) {
          if (companyId == null) {
            provider.clearIdentity()
          }
          provider.identify(String(userId))
        } else {
          provider.clearIdentity()
        }

        if (companyId != null) {
          provider.setContext({ companyId: String(companyId) })
        }
      },
      { immediate: true }
    )

    nuxtApp.provide('analytics', provider)
  }
})
